export const lmnpFiscalLawChoices = [
  { value: 'BIC', label: 'BIC', suffix: { title: 'A' } },
  {
    value: 'MICRO_BIC',
    label: 'Micro-BIC longue durée',
    suffix: { title: 'B' },
  },
  { value: 'CENSI_BOUVARD', label: 'Censi-Bouvard', suffix: { title: 'C' } },
  {
    value: 'MICRO_BIC_TOURISME_CLASSE',
    label: 'Micro-BIC meublé de tourisme classé',
    suffix: { title: 'D' },
  },
  {
    value: 'MICRO_BIC_TOURISME_NON_CLASSE',
    label: 'Micro-BIC meublé de tourisme non classé',
    suffix: { title: 'E' },
  },
];

export const lmnpFiscalLawSelectOptions = lmnpFiscalLawChoices.map(
  ({ value, label }) => ({ id: value, value: label }),
);
